import {
    permissionRoutes,
    settingsRoutes
} from '@/Routes'
import OrgService from '@/services/OrgService.js'
const state = {
    routes: permissionRoutes,
    settingsRoutes: settingsRoutes,
    addRoutes: [],
    role_name: "",
    isallowedroutes: {},
    theme_name: {
        'microsoft-blue': true
    },
    org_details: {},
    inv_settings_details: "",
    cus_settings_details: "",
    vdr_settings_details: "",
    crdt_settings_details: "",
    general_settings_details: "",
    quot_settings_details: "",
    pdt_settings_details: "",
    cus_adv_settings_details: "",
    pymnt_settings_details: "",
    bill_settings_details: "",
    purchase_order_settings_details: "",
    retainer_settings_details: "",
    rec_inv_settings_details: "",
    sales_order_settings_details: "",
    amc_settings_details: "",
    req_settings_details: "",
    vendor_deposit_settings_details: "",
    vdr_crdt_settings_details: "",
    permission: '',
    orgCurrencySymbol: '',
    orgCurrency: '',
    primary_warehouse_details: '',
    print_settings_details: {},
    price_list: {},
    reporting_tags: [],
    org_currency_id:''
}
const mutations = {
    SET_ROUTES: (state, roles) => {
        // state.addRoutes = routes
        state.role_name = roles.role_name
        state.isallowedroutes = roles.isallowedroutes
        state.theme_name = roles.theme_name
        state.org_details = roles.org_details
        state.org_currency_id = roles.org_details.org_currency
        state.inv_settings_details = roles.inv_settings_details
        state.cus_settings_details = roles.cus_settings_details
        state.vdr_settings_details = roles.vdr_settings_details
        state.crdt_settings_details = roles.crdt_settings_details
        state.quot_settings_details = roles.quot_settings_details
        state.req_settings_details = roles.req_settings_details
        state.general_settings_details = roles.general_settings_details
        state.pdt_settings_details = roles.pdt_settings_details
        state.cus_adv_settings_details = roles.cus_adv_settings_details
        state.pymnt_settings_details = roles.pymnt_settings_details
        state.retainer_settings_details = roles.retainer_settings_details
        state.rec_inv_settings_details = roles.rec_inv_settings_details
        state.amc_settings_details = roles.amc_settings_details
        state.sales_order_settings_details = roles.sales_order_settings_details
        state.purchase_order_settings_details = roles.purchase_order_settings_details
        state.bill_settings_details = roles.bill_settings_details
        state.vendor_deposit_settings_details = roles.vendor_deposit_settings_details
        state.vdr_crdt_settings_details = roles.vdr_crdt_settings_details
        state.rec_bill_settings_details = roles.rec_bill_settings_details
        state.price_list = roles.price_list
        state.primary_warehouse_details = roles.primary_warehouse_details,
            state.reporting_tags = roles.reporting_tags
        for (var i = 0; i < roles.print_settings_details.length; i++) {
            state.print_settings_details[roles.print_settings_details[i]['app_menu']] = JSON.parse(roles.print_settings_details[i]['print_stg'])
        }
    }
}
const actions = {
    generateRoutes({
        commit
    }, data) {
        return new Promise((resolve, reject) => {
            OrgService.app.postRoute(data)
                .then(response => {
                    const {
                        isallowedroutes,
                        role_name,
                        general_settings_details

                    } = response.data

                    commit('SET_ROUTES', response.data)
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}